import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@25.9.1_@vue+compiler-sfc@3.5.34_cac@6.7.1_951d5c26bdf6dc24cce7cb313c371f32/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}